import { ShieldCheck, Calendar, XCircle } from "lucide-react";
import { Section } from "@/components/ui/Section";
import { Card } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { Reveal } from "@/components/common/Reveal";
import { BUSINESS, WARRANTY } from "@/utils/constants";

export const Warranty = () => (
  <Section id="warranty" testId="warranty-section" bg="charcoal" blueprint blueprintOpacity={0.22}>
    <Reveal>
      <div className="inline-flex items-center gap-2 rounded-full border border-weld/40 bg-weld/10 px-4 py-1.5 mb-6">
        <ShieldCheck className="text-weld-glow" size={16} />
        <span className="text-weld-glow text-xs font-semibold uppercase tracking-[0.2em]">Our Promise</span>
      </div>
      <h2 className="font-display text-5xl md:text-6xl text-white leading-none">{WARRANTY.title}</h2>
      <p className="text-white/65 mt-5 max-w-3xl leading-relaxed">{WARRANTY.intro}</p>
    </Reveal>

    <Reveal delay={0.1}>
      <Card className="mt-10 p-7 md:p-8">
        <div className="flex items-center gap-2 mb-5">
          <XCircle className="text-white/40" size={18} />
          <h3 className="text-white font-bold uppercase tracking-wide text-sm">This warranty does NOT cover</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3">
          {WARRANTY.notCovered.map((item) => (
            <div key={item} className="flex items-center gap-2 text-white/55 text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-white/25 shrink-0" /> {item}
            </div>
          ))}
        </div>
      </Card>
    </Reveal>

    <Reveal delay={0.15}>
      <Button data-testid="warranty-book" href={BUSINESS.bookUrl} target="_blank" rel="noopener noreferrer" size="lg" className="mt-8">
        <Calendar size={18} /> Book With Confidence
      </Button>
    </Reveal>
  </Section>
);
